import { createSelector } from 'reselect';
import { getLocale } from '@americanexpress/conditional-features/build/selectors/localeSelector';
import { getSafeLocaleUtil } from '@/helpers/utils';

export const getLocaleData = (state) => {
  // getLocale pulls the activeLocale property from the state
  // "activeLocale" is set at the route level in the childRoutes.jsx file using the "onEnterSetSafeLocaleFromRoute" function.
  // which dispatches the OneApp Redux action "updateLocale" which triggers the "case" seen in the below URL
  // https://github.com/americanexpress/one-app-ducks/blob/main/src/intl/index.js#L55
  const localeFromState = getLocale(state) || 'en-US';
  const safeLocale = getSafeLocaleUtil(localeFromState);
  return {
    locale: safeLocale || localeFromState.toLowerCase(),
  };
};

export const getIsMarketWithTranslations = createSelector(
  getLocaleData,
  ({ locale }) => !locale.includes('en')
);
